import { render, staticRenderFns } from "./ModalEliminarDocumento.vue?vue&type=template&id=561fda03&scoped=true&"
import script from "./ModalEliminarDocumento.vue?vue&type=script&lang=js&"
export * from "./ModalEliminarDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561fda03",
  null
  
)

export default component.exports